/**
 * 本文件用于定义blockly中使用的公用颜色值
 */
window.goog.provide('Blockly.Msg.en');
window.goog.require('Blockly.Msg');

// window.Blockly.Msg["NUWA_CATEGORY_EVENT_HUE"] = "#80ba00";
// window.Blockly.Msg["NUWA_CATEGORY_MORE_HUE"] = "#b5b2ff";
// window.Blockly.Msg["NUWA_CATEGORY_START_HUE"] = "#cc0000";
// window.Blockly.Msg["NUWA_CATEGORY_MOTION_HUE"] = "#64ddc3";
// window.Blockly.Msg["NUWA_CATEGORY_FACE_HUE"] = "#9fdf5e";
// window.Blockly.Msg["NUWA_CATEGORY_LIGHT_HUE"] = "#ffbcde";
// window.Blockly.Msg["NUWA_CATEGORY_SOUND_HUE"] = "#ffb2bb";
// window.Blockly.Msg["NUWA_CATEGORY_ANIMATION_HUE"] = "#ecf148";
// window.Blockly.Msg["NUWA_CATEGORY_CONTROL_HUE"] = "#80baff";


// 自定义block背景色
window.Blockly.Msg["NUWA_CATEGORY_DEFAULT_COLOR"] = "#333333";//默认颜色
window.Blockly.Msg["NUWA_CATEGORY_START_COLOR"] = "#ffec86"; // 开始
window.Blockly.Msg['NUWA_CATEGORY_CONTROL_COLOR'] = '#7bb0e6' // 控制
window.Blockly.Msg["NUWA_CATEGORY_MOTION_COLOR"] = "#ecf148"; // 动作
window.Blockly.Msg["NUWA_CATEGORY_FACE_COLOR"] = "#f47e76"; // 脸部
window.Blockly.Msg['NUWA_CATEGORY_LIGHT_COLOR'] = '#efa4ff' // 灯光
window.Blockly.Msg['NUWA_CATEGORY_SOUND_COLOR'] = '#ffb2bb' // 声音
window.Blockly.Msg['NUWA_CATEGORY_ANIMATION_COLOR'] = '#ffd06a' // 动画表演
window.Blockly.Msg['NUWA_CATEGORY_LOOP_COLOR'] = '#aeec67' // 循环
window.Blockly.Msg['NUWA_CATEGORY_LOGIC_COLOR'] = '#6dbc73' // 逻辑
window.Blockly.Msg['NUWA_CATEGORY_FFUNCTION_COLOR'] = '#70dcc8' // 流程
window.Blockly.Msg['NUWA_CATEGORY_VARIABLE_COLOR'] = '#9dddd6' // 变量
window.Blockly.Msg['NUWA_CATEGORY_MATH_COLOR'] = '#3aa4f9' // 数学
window.Blockly.Msg['NUWA_CATEGORY_TEXT_COLOR'] = '#b5b2ff' // 文字
window.Blockly.Msg['NUWA_CATEGORY_LIST_COLOR'] = '#b157ce' // 列表
window.Blockly.Msg['NUWA_CATEGORY_MQTT_COLOUR'] = "#31FFFF" //MQTT連線
window.Blockly.Msg['NUWA_CATEGORY_AIOT_COLOUR'] = "#00FFAC" //AIOT
window.Blockly.Msg['NUWA_CATEGORY_MATERIALLIB_COLOUR'] = "#e1962b";//素材库
window.Blockly.Msg['NUWA_RECOGNIZE_BLOCK_COLOR'] = "#29bde5"

// Blockly.HSV_SATURATION = 1// 0 (inclusive) to 1 (exclusive), defaulting to 0.45
// Blockly.HSV_VALUE = 1 //
